import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Grid, Step, Typography, useTheme } from "@material-ui/core";
import Barcode from "react-barcode";
import moment from "moment";
import DefaultPhoto from "../../assets/img/patron.jpg";
import DefaultPhotoLight from "../../assets/img/patronLight.jpg";
import { UserContext } from "../../contexts/UserContext";
import { PaneContext } from "../../contexts/PaneContext";
import { DatabaseContext } from "../../contexts/DatabaseContext";
import Axios from "axios";
import { SettingsInputAntennaTwoTone } from "@material-ui/icons";
import { enqueueSnackbar } from "notistack";

export const PatronDetails = ({ patron }) => {
  const { apiUrl } = useContext(DatabaseContext);
  const { previewPanePhoto, changeTab } = useContext(PaneContext);
  const { palette } = useTheme();
  const [DateOrdered, setOrderDate] = useState([]);
  const { Site } = useContext(UserContext);
  const [patronImage, setPatronImage] = useState("");
  const {
    siteCode,
    siteType,
    autoBarcode,
    barcodeEnabled,
    barcodePrefix,
    barcodeSuffix,
    printedBarcode,
    theme,
  } = Site;

  const patronLabel = siteType === 0 || siteType === 5 ? "Student" : "Staff";

  const {
    externalID,
    firstName,
    lastName,
    dateOfBirth,
    street,
    suburb,
    state,
    postcode,
    curriculum,
    custom1,
    custom2,
    custom3,
    hasPhoto,
    PSN,
  } = patron;

  const placeholderImage =
    "https://office.monitorwa.com.au/idcaptureapi/defaults/patron.jpg";

  const onImageError = (e) => {
    e.target.src = placeholderImage;
  };

  useEffect(() => {
    (async () => {
      let res = null;
      try {
        res = await Axios.get(
          `${apiUrl}/api/library/orderdate/?siteCode=${siteCode}&externalID=${externalID}`
        );
      } catch (err) {
        if (err.response.status == 404) {
          setOrderDate("No Orders");
        }
      } finally {
        if (res != null) {
          setOrderDate(res.data.data[0][0].dateCreated);
        } else {
          setOrderDate("No Orders");
        }
      }

      if (patron.hasPhoto === true) {
        try {
          let img = new Image();
          img.src = `${apiUrl}/uploads/${Site.siteCode}/${externalID}.jpg`;
          if (img.complete) {
            setPatronImage(img.src);
          } else {
            img.onerror = () => {
              setPatronImage(placeholderImage);
            };
          }
        } catch (err) {
          console.log(err);
          setPatronImage(placeholderImage);
        }
      } else {
        setPatronImage(placeholderImage);
      }
    })();
  });

  if (firstName != undefined && lastName != undefined) {
    var a = firstName.length;

    var b = lastName.length;

    var c = a + b;
  } else {
    c = "";
  }

  return (
    <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
      <Grid item xs={3}>
        {/* <PatronPhoto
          image={
            hasPhoto
              ? previewPanePhoto || theme === 'dark'
              : `${apiUrl}/uploads/${Site.siteCode}/${externalID}.jpg`
              ? DefaultPhoto
              : DefaultPhotoLight
          }
          onClick={() => changeTab(1)}
        /> */}
        <img
          style={{ borderRadius: "8px" }}
          src={patronImage ? patronImage : placeholderImage}
          // src={
          //   hasPhoto
          //     ? previewPanePhoto || theme === 'dark'
          //     : `${apiUrl}/uploads/${Site.siteCode}/${img}`
          //     ? DefaultPhoto
          //     : DefaultPhotoLight
          // }
          width="180px"
          border="1px solid"
          paddingTop="119.5137%"
          height="235px"
          backgroundSize="cover"
          onClick={() => changeTab(1)}
          onError={onImageError}
        />
      </Grid>
      <Grid item xs={9}>
        {c > 29 ? (
          <Name style={{ fontSize: "110%", textTransform: "capitalize" }}>
            {firstName} <br /> {lastName}
          </Name>
        ) : (
          <Name>
            {firstName} {lastName}
          </Name>
        )}
        <br />
        <DetailsContainer>
          <PatronDetail>
            <Label>{patronLabel} ID:</Label>
            <Data>{externalID}</Data>
          </PatronDetail>
          {siteType === 0 || siteType === 5 ? (
            <>
              <PatronDetail>
                <Label>Curriculum:</Label>
                <Data>{curriculum}</Data>
              </PatronDetail>
              <PatronDetail>
                <Label>Date of Birth:</Label>
                <Data>
                  {moment(dateOfBirth).locale("en-au").format("DD/MM/YYYY")}
                </Data>
              </PatronDetail>
            </>
          ) : (
            <></>
          )}
          {barcodeEnabled && (
            <PatronDetail>
              <Label>Barcode:</Label>
              <Barcode
                value={`${autoBarcode ? barcodePrefix : ""}${
                  printedBarcode === "externalID"
                    ? externalID
                    : printedBarcode === "curriculum"
                    ? curriculum
                    : printedBarcode === "custom1"
                    ? custom1
                    : printedBarcode === "custom2"
                    ? custom2
                    : printedBarcode === "custom3"
                    ? custom3
                    : ""
                }${autoBarcode ? barcodeSuffix : ""}`}
                format="CODE128"
                background="none"
                lineColor={theme === "dark" ? "#fff" : "#5b63aa"}
                height={14}
                width={1}
                marginLeft={1}
                marginTop={3}
                marginBottom={1}
                marginRight={0}
                fontSize={10}
              />
            </PatronDetail>
          )}
        </DetailsContainer>
        <DetailsContainer>
          {(Site.showAddress && siteType === 0) ||
          (Site.showAddress && siteType === 5) ? (
            <PatronDetail>
              <Label>Address:</Label>
              <Data style={{ textTransform: "capitalize" }}>{street},</Data>
              <Data style={{ textTransform: "capitalize" }}>{suburb}</Data>
              <Data>
                {state} {postcode}
              </Data>
            </PatronDetail>
          ) : (
            <></>
          )}

          {Site.custom1Enabled && (
            <PatronDetail>
              <Label>{Site.custom1}</Label>
              <Data blank={!custom1} blankText={palette.text.secondary}>
                {custom1 || "N/A"}
              </Data>
            </PatronDetail>
          )}

          {Site.custom2Enabled && (
            <PatronDetail>
              <Label>{Site.custom2}</Label>
              <Data blank={!custom2} blankText={palette.text.secondary}>
                {custom2 || "N/A"}
              </Data>
            </PatronDetail>
          )}

          {Site.custom3Enabled && (
            <PatronDetail>
              <Label>{Site.custom3}</Label>
              <Data blank={!custom3} blankText={palette.text.secondary}>
                {custom3 || "N/A"}
              </Data>
            </PatronDetail>
          )}

          <PatronDetail>
            <Label style={{ color: "yellow" }}>Last Ordered Date</Label>
            <Data style={{ color: "yellow" }}>{DateOrdered}</Data>
          </PatronDetail>
          <br />
          <br />
          {siteType === 0 ? (
            <PatronDetail>
              <Label>SmartRider Number</Label>
              <Data>{PSN}</Data>
            </PatronDetail>
          ) : (
            <></>
          )}
        </DetailsContainer>
      </Grid>
    </Grid>
  );
};

const PatronPhoto = styled.div`
  background-image: ${(props) => `url(${props.image})`};
  background-size: cover;
  width: 90%;
  border-radius: 1rem;
  border: 1px solid;
  padding-top: 119.5137%;
  height: 0;
  cursor: pointer;
`;

const Name = styled(Typography)`
  font-size: 2.4rem;
  font-weight: 700;
  padding: 1rem 0;
  margin-bottom: 1rem;
`;

const DetailsContainer = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;
const PatronDetail = styled.div`
  margin-right: 2.2rem;
`;

const Label = styled(Typography)`
  font-size: 1.4rem;
  font-weight: 700;
  font-style: italic;
`;
const Data = styled(Typography)`
  font-size: 1.8rem;
  ${(props) => props.blank && `color: ${props.blankText}`}
`;
